import { saveBlob, openUrl } from '../utils/nativeFiles';

// API Configuration
// Change this URL to your actual API endpoint when going live
// export const API_BASE_URL = 'http://localhost:4000'; // Update this to your real API URL
// export const API_BASE_URL = 'https://ro.zunpure.com:5051'; // Update this to your real API URL
// export const API_BASE_URL = 'https://ro.zunpure.com:5053'; // Update this to your real API URL

export const API_BASE_URL = 'https://api.zun.energy';

const CRM_API_BASE_URL = `${API_BASE_URL}/crm/oms`;

const enc = (v) => encodeURIComponent(String(v ?? ''));


// API endpoints
export const API_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/login/oms/login`,
  SIGNUP: `${API_BASE_URL}/login/oms/signup`,
  ORDERS: `${API_BASE_URL}/orders/oms/fetchAll`,
  ORDER_DETAIL: (id) => `${API_BASE_URL}/orders/oms/fetchDetails?orderId=${enc(id)}`,
  CONFIRM_ORDER: (id) => `${API_BASE_URL}/orders/oms/confirmorder?orderId=${enc(id)}`,
  UPDATE_ORDER_STATUS: (id) => `${API_BASE_URL}/orders/oms/updateStatus?orderId=${enc(id)}`,
  GET_PRODUCTS: `${API_BASE_URL}/listings/getProductMapping`,
  CREATE_ORDER: `${API_BASE_URL}/orders/oms/createOrder`,
  VERIFY_ORDER_OTP: `${API_BASE_URL}/orders/oms/verifyOrderOtp`,
  OMS_USERS: `${API_BASE_URL}/login/oms/allOmsUsers`,
  OMS_ROLE_UPDATE: `${API_BASE_URL}/login/oms/updateRole`,
  OMS_ACCESS_UPDATE: `${API_BASE_URL}/login/oms/updateAccess`, 
  OMS_WAREHOUSE_ACCESS_UPDATE: `${API_BASE_URL}/login/oms/updateWarehouseAccess`,
  OMS_STATUS_UPDATE: `${API_BASE_URL}/login/oms/updateStatus`,
  OMS_DELETE_USER: (id) => `${API_BASE_URL}/login/oms/deleteUser?userId=${enc(id)}`,
  UPDATE_WAREHOUSE_SETTINGS: `${API_BASE_URL}/warehouses/updateWarehouseSettings`,
  GET_WAREHOUSES: `${API_BASE_URL}/listings/getWarehouseList`,
  WALLET_PAYMENTS: `${API_BASE_URL}/payment/oms/wallet/fetchPayments`,
  APPROVE_WALLET_PAYMENT: (id) => `${API_BASE_URL}/payment/oms/wallet/approvePayment?paymentId=${enc(id)}`,
  LIVE_WHATSAPP_CHATS: `${API_BASE_URL}/whatsapp/live/chats`,
  LIVE_WHATSAPP_CHAT_MESSAGES: (chatId) =>
    `${API_BASE_URL}/whatsapp/live/chats/${encodeURIComponent(chatId)}/messages`,
  LIVE_WHATSAPP_MESSAGES: `${API_BASE_URL}/whatsapp/live/messages`,
  LIVE_WHATSAPP_STREAM: `${API_BASE_URL}/whatsapp/live/stream`,
  // Notification management API functions — Legacy broadcast
  SEND_NOTIFICATION: `${API_BASE_URL}/notifications/oms/send`,
  NOTIFICATION_HISTORY: `${API_BASE_URL}/notifications/oms/fetchAll`,
  // Notification — Trigger configs
  NOTIFICATION_TRIGGER_CONFIGS: `${API_BASE_URL}/notifications/oms/trigger-configs`,
  NOTIFICATION_TRIGGER_CONFIG: (subtype) => `${API_BASE_URL}/notifications/oms/trigger-configs/${enc(subtype)}`,
  // Notification — Expiry reminder configs
  NOTIFICATION_EXPIRY_REMINDER_CONFIGS: `${API_BASE_URL}/notifications/oms/expiry-reminder-configs`,
  NOTIFICATION_EXPIRY_REMINDER_CONFIG: (id) => `${API_BASE_URL}/notifications/oms/expiry-reminder-configs/${enc(id)}`,
  // Notification — Expiry reminder send history
  NOTIFICATION_EXPIRY_REMINDER_LOGS: `${API_BASE_URL}/notifications/oms/expiry-reminder-logs`,
  // Notification — Funnel re-engagement configs
  NOTIFICATION_FUNNEL_CONFIGS: `${API_BASE_URL}/notifications/oms/funnel-configs`,
  NOTIFICATION_FUNNEL_CONFIG: (stage) => `${API_BASE_URL}/notifications/oms/funnel-configs/${enc(stage)}`,
  // Notification — Funnel re-engagement send history
  NOTIFICATION_FUNNEL_LOGS: `${API_BASE_URL}/notifications/oms/funnel-logs`,
  // Notification — Campaigns
  NOTIFICATION_CAMPAIGNS: `${API_BASE_URL}/notifications/oms/campaigns`,
  NOTIFICATION_CAMPAIGN: (id) => `${API_BASE_URL}/notifications/oms/campaigns/${enc(id)}`,
  NOTIFICATION_CAMPAIGN_DELETE: (id) => `${API_BASE_URL}/notifications/oms/campaigns/${enc(id)}`,
  NOTIFICATION_CAMPAIGN_SEND: (id) => `${API_BASE_URL}/notifications/oms/campaigns/${enc(id)}/send`,
  NOTIFICATION_CAMPAIGN_STATS: (id) => `${API_BASE_URL}/notifications/oms/campaigns/${enc(id)}/stats`,
  NOTIFICATION_SURVEY_STATS: (id) => `${API_BASE_URL}/notifications/oms/campaigns/${enc(id)}/survey-stats`,
  NOTIFICATION_SURVEY_RESPONSES: (id) => `${API_BASE_URL}/notifications/oms/campaigns/${enc(id)}/survey-responses`,
  VBA_ALL: `${API_BASE_URL}/vba/oms/all`,
  VBA_PAYMENTS: (virtualAccountId) => `${API_BASE_URL}/vba/oms/${enc(virtualAccountId)}/payments`,
  COUPONS: `${API_BASE_URL}/coupon/fetchAll`,
  COUPON_DETAIL: (id) => `${API_BASE_URL}/coupon/fetchById?couponId=${enc(id)}`,
  CREATE_COUPON: `${API_BASE_URL}/coupon/create`,
  TOGGLE_COUPON_STATUS: (id) => `${API_BASE_URL}/coupon/toggleCoupon`,
  FORGOT_PASSWORD: `${API_BASE_URL}/login/oms/forgotPassword`,
  VERIFY_RESET_TOKEN: `${API_BASE_URL}/login/oms/verifyResetToken`,
  RESET_PASSWORD: `${API_BASE_URL}/login/oms/resetPassword`,
  // Hub Management
  GET_HUBS: `${API_BASE_URL}/hubs/oms/list`,
  GET_HUB_SETTINGS: (hubId) => `${API_BASE_URL}/hubs/oms/${enc(hubId)}/settings`,
  UPDATE_HUB_GENERAL: (hubId) => `${API_BASE_URL}/hubs/oms/${enc(hubId)}/general`,
  UPDATE_HUB_DELIVERY_FEES: (hubId) => `${API_BASE_URL}/hubs/oms/${enc(hubId)}/delivery-fees`,
  UPDATE_HUB_HANDLING_CHARGES: (hubId) => `${API_BASE_URL}/hubs/oms/${enc(hubId)}/handling-charges`,
  GET_HUB_PINCODES: (hubId) => `${API_BASE_URL}/hubs/oms/${enc(hubId)}/pincodes`,
  ADD_HUB_PINCODE: (hubId) => `${API_BASE_URL}/hubs/oms/${enc(hubId)}/pincodes/add`,
  REMOVE_HUB_PINCODE: (hubId) => `${API_BASE_URL}/hubs/oms/${enc(hubId)}/pincodes/remove`,
  TOGGLE_PINCODE_FAR_AREA: (hubId) => `${API_BASE_URL}/hubs/oms/${enc(hubId)}/pincodes/far-area`,
  SEARCH_HUB_PINCODE: (pincode) => `${API_BASE_URL}/hubs/oms/pincodes/search?pincode=${enc(pincode)}`,
  OMS_DEALS_BANNERS: `${API_BASE_URL}/listings/oms/deals-banners`,
  OMS_GIFT_CONFIG: `${API_BASE_URL}/listings/oms/gift-config`,
  // Brand Support
  BRAND_SUPPORT_LIST: `${API_BASE_URL}/brand-support/oms/list`,
  BRAND_SUPPORT_CREATE: `${API_BASE_URL}/brand-support/oms/create`,
  BRAND_SUPPORT_UPDATE: (id) => `${API_BASE_URL}/brand-support/oms/${enc(id)}`,
  BRAND_SUPPORT_DELETE: (id) => `${API_BASE_URL}/brand-support/oms/${enc(id)}`,
  // CRM — Leads
  CRM_LEADS: `${CRM_API_BASE_URL}/leads`,
  CRM_LEADS_EXPORT: `${CRM_API_BASE_URL}/leads/export`,
  CRM_LEAD_TAG_OPTIONS: `${CRM_API_BASE_URL}/leads/tag-options`,
  CRM_LEAD_DETAIL: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}`,
  CRM_LEAD_STAGE: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}/stage`,
  CRM_LEAD_ARCHIVE: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}/archive`,
  CRM_LEAD_DELETE: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}/permanent`,
  CRM_LEAD_TIMELINE: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}/timeline`,
  CRM_LEAD_CALL: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}/call`,
  CRM_LEAD_DISPOSITION: (leadId, callId) => `${CRM_API_BASE_URL}/leads/${enc(leadId)}/calls/${enc(callId)}/disposition`,
  CRM_LEAD_QUICK_DISPOSITION: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}/quick-disposition`,
  CRM_LEAD_COMMENTS: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}/comments`,
  CRM_LEAD_COMMENT_EXPORT: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}/comments/export`,
  CRM_VIDEO_CALL_REQUEST_STATUS: (leadId, requestId) =>
    `${CRM_API_BASE_URL}/leads/${leadId}/video-call-requests/${encodeURIComponent(requestId)}/status`,
  CRM_DASHBOARD: `${CRM_API_BASE_URL}/dashboard`,
  CRM_DASHBOARD_HUBS: `${CRM_API_BASE_URL}/dashboard/hubs`,
  CRM_DASHBOARD_COMMENT_EXPORT: `${CRM_API_BASE_URL}/dashboard/comments/export`,
  CRM_LEAD_WHATSAPP: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}/whatsapp`,
  CRM_LEAD_CONVERSATIONS: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}/conversations`,
  CRM_LEAD_CONTACT_WHATSAPP: (leadId, contactId) =>
    `${CRM_API_BASE_URL}/leads/${enc(leadId)}/contacts/${enc(contactId)}/whatsapp`,
  CRM_LEAD_CONTACT_WHATSAPP_READ: (leadId, contactId) =>
    `${CRM_API_BASE_URL}/leads/${enc(leadId)}/contacts/${enc(contactId)}/whatsapp/read`,
  CRM_LEAD_CONTACTS: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}/contacts`,
  CRM_LEAD_CONTACT: (leadId, contactId) => `${CRM_API_BASE_URL}/leads/${enc(leadId)}/contacts/${enc(contactId)}`,
  CRM_LEAD_HUB_LINKS: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}/hub-links`,
  CRM_LEAD_HUB_LINK: (leadId, hubId) => `${CRM_API_BASE_URL}/leads/${enc(leadId)}/hub-links/${enc(hubId)}`,
  CRM_LEAD_EXTERNAL_IDS: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}/external-ids`,
  CRM_LEAD_EXTERNAL_ID: (leadId, externalIdId) => `${CRM_API_BASE_URL}/leads/${enc(leadId)}/external-ids/${enc(externalIdId)}`,
  CRM_LEAD_MERGE: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}/merge`,
  CRM_LEAD_SPLIT: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}/split`,
  CRM_OMS_USER_SEARCH: `${CRM_API_BASE_URL}/oms-users/search`,
  CRM_ORDER_GST_SEARCH: `${CRM_API_BASE_URL}/order-gsts/search`,
  CRM_PMSG_VENDOR_SEARCH: `${CRM_API_BASE_URL}/pmsg/vendors/search`,
  CRM_STAFF_SEARCH: `${CRM_API_BASE_URL}/staff/search`,
  CRM_LEAD_ASSIGNMENT: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}/assignment`,
  CRM_BULK_ASSIGNMENT: `${CRM_API_BASE_URL}/leads/bulk/assignment`,
  CRM_BULK_HUB_LINKS: `${CRM_API_BASE_URL}/leads/bulk/hub-links`,
  CRM_BULK_CONFIRM_HUB_SUGGESTIONS: `${CRM_API_BASE_URL}/leads/bulk/confirm-hub-suggestions`,
  CRM_BULK_TAGS: `${CRM_API_BASE_URL}/leads/bulk/tags`,
  CRM_BULK_VARIABLE_VALUES: `${CRM_API_BASE_URL}/leads/bulk/variable-values`,
  CRM_LEAD_CSV_IMPORT: `${CRM_API_BASE_URL}/leads/import-csv`,
  CRM_PMSG_CSV_IMPORT: `${CRM_API_BASE_URL}/pmsg/snapshots/import-csv`,
  CRM_VARIABLE_CSV_IMPORT: `${CRM_API_BASE_URL}/leads/variables/import-csv`,
  CRM_LEAD_TAGS: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}/tags`,
  CRM_LEAD_VARIABLES: (id) => `${CRM_API_BASE_URL}/leads/${enc(id)}/variables`,
  CRM_VARIABLES: `${CRM_API_BASE_URL}/variables`,
  CRM_HISTORY: `${CRM_API_BASE_URL}/history`,
  // CRM — Saved filters
  CRM_SAVED_FILTERS: `${CRM_API_BASE_URL}/saved-filters`,
  CRM_SAVED_FILTER_DELETE: (id) => `${CRM_API_BASE_URL}/saved-filters/${enc(id)}`,
  // CRM — Settings (admin only)
  CRM_SETTINGS_VARIABLES: `${CRM_API_BASE_URL}/settings/variables`,
  CRM_SETTINGS_VARIABLE: (id) => `${CRM_API_BASE_URL}/settings/variables/${enc(id)}`,
  CRM_DISPOSITIONS: `${CRM_API_BASE_URL}/dispositions`,
  CRM_SETTINGS_VIEWS: `${CRM_API_BASE_URL}/settings/views`,
  CRM_SETTINGS_VIEW: (id) => `${CRM_API_BASE_URL}/settings/views/${enc(id)}`,
  CRM_SETTINGS_DISPOSITIONS: `${CRM_API_BASE_URL}/settings/dispositions`,
  CRM_SETTINGS_DISPOSITION: (id) => `${CRM_API_BASE_URL}/settings/dispositions/${enc(id)}`,
  CRM_SETTINGS_HUB_NUMBERS: `${CRM_API_BASE_URL}/settings/hub-numbers`,
  CRM_SETTINGS_HUB_NUMBER: (hubId) => `${CRM_API_BASE_URL}/settings/hub-numbers/${enc(hubId)}`,
  CRM_SETTINGS_SMARTFLO_AGENTS: `${CRM_API_BASE_URL}/settings/smartflo-agents`,
  CRM_SMARTFLO_USER: (smartfloUserId) =>
    `${CRM_API_BASE_URL}/smartflo/users/${encodeURIComponent(smartfloUserId)}`,
  CRM_SETTINGS_SMARTFLO_CALLER_IDS: `${CRM_API_BASE_URL}/settings/smartflo-agents/caller-ids`,
  CRM_SETTINGS_SMARTFLO_ROLES: `${CRM_API_BASE_URL}/settings/smartflo-agents/roles`,
};

// API helper functions
export const apiCall = async (url, options = {}) => {
  const token = localStorage.getItem('authToken');
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  };

  const response = await fetch(url, {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return;
  }

  if (!response.ok) {
    let errorMessage = `HTTP error! status: ${response.status}`;
    let errorDetails = null;
    let errorCode = null;

    try {
      const contentType = response.headers.get('content-type') || '';

      if (contentType.includes('application/json')) {
        const errorData = await response.json();
        errorDetails = errorData?.errors || null;
        errorCode = errorData?.code || null;
        errorMessage =
          errorData?.message ||
          errorData?.error ||
          errorData?.msg ||
          errorMessage;
      } else {
        const errorText = await response.text();
        if (errorText) {
          errorMessage = errorText;
        }
      }
    } catch (_) {
      // Keep default HTTP status-based message if parsing fails.
    }

    const error = new Error(errorMessage);
    error.details = errorDetails;
    error.code = errorCode;
    throw error;
  }

  return response.json();
};

export const login = async (credentials) => {
  return apiCall(API_ENDPOINTS.LOGIN, {
    method: 'POST',
    body: JSON.stringify(credentials),
  });
};

export const signup = async (credentials) => {
  return apiCall(API_ENDPOINTS.SIGNUP, {
    method: 'POST',
    body: JSON.stringify(credentials),
  });
};

// Password reset API functions
export const requestPasswordReset = async (email) => {
  return apiCall(API_ENDPOINTS.FORGOT_PASSWORD, {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
};

export const verifyResetToken = async (token) => {
  return apiCall(API_ENDPOINTS.VERIFY_RESET_TOKEN, {
    method: 'POST',
    body: JSON.stringify({ token }),
  });
};

export const resetPassword = async (token, newPassword) => {
  return apiCall(API_ENDPOINTS.RESET_PASSWORD, {
    method: 'POST',
    body: JSON.stringify({ token, newPassword }),
  });
};

export const getOrders = async (filters = {}) => {
  const queryParams = new URLSearchParams();
  
  // Add all filter parameters
  Object.keys(filters).forEach(key => {
    const value = filters[key];
    
    // Handle array values (for multi-select filters)
    if (Array.isArray(value)) {
      if (value.length > 0) {
        // Append each array item as a separate parameter
        value.forEach(item => {
          queryParams.append(key, item);
        });
      }
    } else if (value && value !== 'all') {
      // Handle single values
      queryParams.append(key, value);
    }
  });
  
  const url = queryParams.toString() ? `${API_ENDPOINTS.ORDERS}?${queryParams}` : API_ENDPOINTS.ORDERS;
  return apiCall(url);
};

export const getProducts = async () => {
  const url = API_ENDPOINTS.GET_PRODUCTS;
  const res = await apiCall(url);
  if (res && res.data && Array.isArray(res.data)) {
    res.data.sort((a, b) =>
      (a.skuCode || '').localeCompare(b.skuCode || '', undefined, { numeric: true, sensitivity: 'base' })
    );
  }
  return res;
};

export const getCategories = async () => {
  return apiCall(`${API_BASE_URL}/home/getCategories?source=oms`);
};

export const getProductPricing = async (warehouseId = 1) => {
  return apiCall(`${API_BASE_URL}/listings/getAllProducts?warehouseId=${enc(warehouseId)}`);
};

export const updateProductPricing = async (pid, priceSlabs) => {
  return apiCall(`${API_BASE_URL}/listings/updatePricing`, {
    method: 'POST',
    body: JSON.stringify({ id: pid, price: priceSlabs }),
  });
};

export const getVirtualHubPricing = async (productId, warehouseId) => {
  return apiCall(`${API_BASE_URL}/listings/virtualHubPricing/${enc(productId)}?warehouseId=${encodeURIComponent(warehouseId)}`);
};

export const updateVirtualHubPricing = async (productId, warehouseId, variations) => {
  return apiCall(`${API_BASE_URL}/listings/virtualHubPricing/${enc(productId)}`, {
    method: 'POST',
    body: JSON.stringify({ warehouseId, variations }),
  });
};

export const getOrderDetail = async (orderId) => {
  return apiCall(API_ENDPOINTS.ORDER_DETAIL(orderId));
};

export const confirmOrder = async (orderId) => {
  return apiCall(API_ENDPOINTS.CONFIRM_ORDER(orderId), {
    method: 'POST',
  });
};

export const updateOrderStatus = async (orderId, status) => {
  return apiCall(API_ENDPOINTS.UPDATE_ORDER_STATUS(orderId), {
    method: 'PUT',
    body: JSON.stringify({ status }),
  });
};

export const createOrder = async (orderData) => {
  return apiCall(API_ENDPOINTS.CREATE_ORDER, {
    method: 'POST',
    body: JSON.stringify(orderData),
  });
};

export const verifyOrderOtp = async (otpData) => {
  return apiCall(API_ENDPOINTS.VERIFY_ORDER_OTP, {
    method: 'POST',
    body: JSON.stringify(otpData),
  })
}

// File management API functions
export const getOrderFiles = async (orderId) => {
  return apiCall(`${API_BASE_URL}/orderFiles/${enc(orderId)}/files/oms`);
};

export const uploadOrderFile = async (orderId, uploadData) => {
  const token = localStorage.getItem('authToken');
  console.log("formData", uploadData);
  const formData = new FormData();
  for (const [key, value] of Object.entries(uploadData)) {
    formData.append(key, value);
  }
  const response = await fetch(`${API_BASE_URL}/orderFiles/${enc(orderId)}/files`, {
    method: 'POST',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: formData, // FormData for file upload
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return;
  }

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  let apiResponse = await response.json();
  return apiResponse.data || {};
};

export const deleteOrderFile = async (orderId, fileId) => {
  return apiCall(`${API_BASE_URL}/orderFiles/${enc(orderId)}/files/${enc(fileId)}`, {
    method: 'DELETE',
  });
};

export const downloadOrderFile = async (orderId, fileId) => {
  const token = localStorage.getItem('authToken');
  
  const response = await fetch(`${API_BASE_URL}/orderFiles/${enc(orderId)}/files/${enc(fileId)}/download/oms`, {
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return;
  }

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  let apiResponse = await response.json();

  if(apiResponse.url) {
    openUrl(apiResponse.url);
  }
};

export const getPrintableOrderFile = async (orderId, fileId) => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(
    `${API_BASE_URL}/orderFiles/${enc(orderId)}/files/${enc(fileId)}/print/oms`,
    { headers: { ...(token && { Authorization: `Bearer ${token}` }) } }
  );
  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return null;
  }
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Could not prepare this document for printing');
  }
  return response.blob();
};

// Product management API functions
export const getAllProducts = async () => {
  // For development, use mock data
  const { getMockProducts } = await import('../data/mockData');
  return getMockProducts();
  
  // For production, uncomment below:
  // return apiCall(`${API_BASE_URL}/products`);
};

// Payment/Ledger management API functions
export const getAllPayments = async (page = 1, limit = 50, filters = {}) => {
  const queryParams = new URLSearchParams();
  queryParams.append('page', page);
  queryParams.append('limit', limit);
  
  // Add filters
  Object.keys(filters).forEach(key => {
    if (filters[key]) {
      queryParams.append(key, filters[key]);
    }
  });
  
  const url = `${API_BASE_URL}/ledger/payments/oms?${queryParams}`;
  return apiCall(url);
};

export const getUserPaymentsByPhone = async (phone, page = 1, limit = 50) => {
  const queryParams = new URLSearchParams();
  queryParams.append('phone', phone);
  queryParams.append('page', page);
  queryParams.append('limit', limit);
  
  const url = `${API_BASE_URL}/ledger/user-payments/oms?${queryParams}`;
  return apiCall(url);
};

export const getUserBalance = async (phone) => {
  const queryParams = new URLSearchParams();
  queryParams.append('phone', phone);
  
  const url = `${API_BASE_URL}/ledger/user-balance/oms?${queryParams}`;
  return apiCall(url);
};

export const createManualPayment = async (paymentData) => {
  return apiCall(`${API_BASE_URL}/ledger/manual-payment/oms`, {
    method: 'POST',
    body: JSON.stringify(paymentData),
  });
};

export const getProductDetail = async (productId) => {
  // For development, use mock data
  // const { getMockProductDetail } = await import('../data/mockData');
  // return getMockProductDetail(productId);
  
  // For production, uncomment below:
  return apiCall(`${API_BASE_URL}/listings/getDetailsOms?productId=${enc(productId)}`);
};

export const createProduct = async (formData) => {
  // For development, use mock data
  // const { createMockProduct } = await import('../data/mockData');
  
  // // Convert FormData to object for mock
  const productData = {};
  for (let [key, value] of formData.entries()) {
    if (key === 'discount_price' || key === 'specifications') {
      try {
        productData[key] = JSON.parse(value);
      } catch (e) {
        productData[key] = value;
      }
    } else if (key === 'category_id' || key === 'wattage') {
      productData[key] = parseInt(value) || null;
    } else if (key === 'price') {
      productData[key] = parseFloat(value) || 0;
    } else if (key === 'is_featured' || key === 'active') {
      productData[key] = value === 'true';
    } else if (key === 'images') {
      // Handle multiple files with same key name - collect into array
      if (!productData[key]) {
        productData[key] = [];
      }
      productData[key].push(value);
    } else {
      productData[key] = value;
    }
  }
  
  console.log("productData", productData);

  const token = localStorage.getItem('authToken');
  
  const response = await fetch(`${API_BASE_URL}/listings/createProduct`, {
    method: 'POST',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: formData,
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return;
  }

  if (!response.ok) {
    // Surface the real backend error instead of a generic HTTP status.
    // The API returns JSON like:
    //   { success: false, message: "...", errors: [{ field, message }] }
    let message = `HTTP error! status: ${response.status}`;
    try {
      const errorBody = await response.json();
      if (errorBody) {
        const parts = [];
        if (errorBody.message) parts.push(errorBody.message);
        // Append per-field validation details when present.
        if (Array.isArray(errorBody.errors) && errorBody.errors.length) {
          const fieldMsgs = errorBody.errors
            .map((e) => (e.field ? `${e.field}: ${e.message}` : e.message))
            .filter(Boolean);
          if (fieldMsgs.length) parts.push(fieldMsgs.join(', '));
        }
        if (parts.length) message = parts.join(' — ');
      }
    } catch (e) {
      // Body wasn't JSON (e.g. HTML error page); keep the status-based message.
    }
    throw new Error(message);
  }

  return response.json();
};

export const updateProduct = async (productId, formData) => {
  // For development, use mock data
  const productData = {};
  for (let [key, value] of formData.entries()) {
    if (key === 'discount_price' || key === 'specifications') {
      try {
        productData[key] = JSON.parse(value);
      } catch (e) {
        productData[key] = value;
      }
    } else if (key === 'category_id' || key === 'wattage') {
      productData[key] = parseInt(value) || null;
    } else if (key === 'price') {
      productData[key] = parseFloat(value) || 0;
    } else if (key === 'is_featured' || key === 'active') {
      productData[key] = value === 'true';
    } else if (key === 'images') {
      if (!productData[key]) {
        productData[key] = [];
      }
      productData[key].push(value);
    } else {
      productData[key] = value;
    }
  }
  
  const token = localStorage.getItem('authToken');
  
  const response = await fetch(`${API_BASE_URL}/listings/editProduct/${enc(productId)}`, {
    method: 'PUT',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: formData,
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return;
  }

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const getOmsUsers = async () => {
  return apiCall(API_ENDPOINTS.OMS_USERS);
};

export const updateUserRole = async (userId, role) => {

  const token = localStorage.getItem('authToken');
  return apiCall(API_ENDPOINTS.OMS_ROLE_UPDATE, {
    method: 'POST',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify({ userId, role }),
  });
};
export const updateUserAccess = async (userId, accessType, isGranted) => {

  const token = localStorage.getItem('authToken');
  return apiCall(API_ENDPOINTS.OMS_ACCESS_UPDATE, {
    method: 'POST',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify({ userId, accessType, isGranted }),
  });
};

export const updateUserStatus = async (userId, status) => {
  const token = localStorage.getItem('authToken');
  return apiCall(API_ENDPOINTS.OMS_STATUS_UPDATE, {
    method: 'POST',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify({ userId, status }),
  });
};

export const deleteUser = async (userId) => {
  const token = localStorage.getItem('authToken');
  return apiCall(API_ENDPOINTS.OMS_DELETE_USER(userId), {
    method: 'POST',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });
};

export const updateUserWarehouseAccess = async (userId, warehouseId, isGranted) => {
  const token = localStorage.getItem('authToken');
  return apiCall(API_ENDPOINTS.OMS_WAREHOUSE_ACCESS_UPDATE, {
    method: 'POST',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify({ userId, warehouseId, isGranted }),
  });
};

export const getWalletPayments = async () => {
  return apiCall(API_ENDPOINTS.WALLET_PAYMENTS);
};

export const approveWalletPayment = async (paymentId, action = 'approved') => {
  const token = localStorage.getItem('authToken');
  return apiCall(`${API_ENDPOINTS.APPROVE_WALLET_PAYMENT(paymentId)}&action=${enc(action)}`, {
    method: 'POST',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });
};

// Notification management API functions
export const sendNotification = async (notificationData) => {
  const token = localStorage.getItem('authToken');
  return apiCall(API_ENDPOINTS.SEND_NOTIFICATION, {
    method: 'POST',
    headers: { ...(token && { Authorization: `Bearer ${token}` }) },
    body: JSON.stringify(notificationData),
  });
};

export const getNotificationHistory = async () => {
  return apiCall(API_ENDPOINTS.NOTIFICATION_HISTORY);
};

// ─── Notification — Trigger Configs ──────────────────────────────────────────

export const getNotificationTriggerConfigs = async () =>
  apiCall(API_ENDPOINTS.NOTIFICATION_TRIGGER_CONFIGS);

export const updateNotificationTriggerConfig = async (subtype, data) =>
  apiCall(API_ENDPOINTS.NOTIFICATION_TRIGGER_CONFIG(subtype), {
    method: 'PUT',
    body: JSON.stringify(data),
  });

// ─── Notification — Expiry Reminder Configs ───────────────────────────────────

export const getExpiryReminderConfigs = async () =>
  apiCall(API_ENDPOINTS.NOTIFICATION_EXPIRY_REMINDER_CONFIGS);

export const updateExpiryReminderConfig = async (id, data) =>
  apiCall(API_ENDPOINTS.NOTIFICATION_EXPIRY_REMINDER_CONFIG(id), {
    method: 'PUT',
    body: JSON.stringify(data),
  });

// ─── Notification — Expiry Reminder Logs (send history) ───────────────────────

export const getExpiryReminderLogs = async (filters = {}) => {
  const q = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => { if (v !== undefined && v !== '') q.append(k, v); });
  const url = `${API_ENDPOINTS.NOTIFICATION_EXPIRY_REMINDER_LOGS}${q.toString() ? '?' + q.toString() : ''}`;
  return apiCall(url);
};

// ─── Notification — Funnel Re-Engagement Configs ──────────────────────────────

export const getFunnelConfigs = async () =>
  apiCall(API_ENDPOINTS.NOTIFICATION_FUNNEL_CONFIGS);

export const updateFunnelConfig = async (stage, data) =>
  apiCall(API_ENDPOINTS.NOTIFICATION_FUNNEL_CONFIG(stage), {
    method: 'PUT',
    body: JSON.stringify(data),
  });

export const getFunnelLogs = async (filters = {}) => {
  const q = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => { if (v !== undefined && v !== '') q.append(k, v); });
  const url = `${API_ENDPOINTS.NOTIFICATION_FUNNEL_LOGS}${q.toString() ? '?' + q.toString() : ''}`;
  return apiCall(url);
};

// ─── Notification — Campaigns ─────────────────────────────────────────────────

export const getNotificationCampaigns = async (filters = {}) => {
  const q = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => { if (v) q.append(k, v); });
  const url = `${API_ENDPOINTS.NOTIFICATION_CAMPAIGNS}${q.toString() ? '?' + q.toString() : ''}`;
  return apiCall(url);
};

export const createNotificationCampaign = async (data) =>
  apiCall(API_ENDPOINTS.NOTIFICATION_CAMPAIGNS, {
    method: 'POST',
    body: JSON.stringify(data),
  });

export const updateNotificationCampaign = async (id, data) =>
  apiCall(API_ENDPOINTS.NOTIFICATION_CAMPAIGN(id), {
    method: 'PUT',
    body: JSON.stringify(data),
  });

export const deleteNotificationCampaign = async (id) =>
  apiCall(API_ENDPOINTS.NOTIFICATION_CAMPAIGN_DELETE(id), {
    method: 'DELETE',
  });

export const sendNotificationCampaign = async (id) =>
  apiCall(API_ENDPOINTS.NOTIFICATION_CAMPAIGN_SEND(id), { method: 'POST' });

export const getNotificationCampaignStats = async (id) =>
  apiCall(API_ENDPOINTS.NOTIFICATION_CAMPAIGN_STATS(id));

export const getSurveyStats = async (id) =>
  apiCall(API_ENDPOINTS.NOTIFICATION_SURVEY_STATS(id));

export const getSurveyResponses = async (id) =>
  apiCall(API_ENDPOINTS.NOTIFICATION_SURVEY_RESPONSES(id));


// ─── B2B Coupon Management API ────────────────────────────────────────────────

export const getB2BCoupons = async (filters = {}) => {
  const queryParams = new URLSearchParams();
  Object.keys(filters).forEach(key => {
    if (filters[key] && filters[key] !== 'all') {
      queryParams.append(key, filters[key]);
    }
  });
  const url = queryParams.toString()
    ? `${API_BASE_URL}/b2b/coupon/fetchAll?${queryParams}`
    : `${API_BASE_URL}/b2b/coupon/fetchAll`;
  return apiCall(url);
};

export const getB2BCouponDetail = async (couponId) => {
  return apiCall(`${API_BASE_URL}/b2b/coupon/fetchById?couponId=${enc(couponId)}`);
};

export const createB2BCoupon = async (couponData) => {
  return apiCall(`${API_BASE_URL}/b2b/coupon/create`, {
    method: 'POST',
    body: JSON.stringify(couponData),
  });
};

export const toggleB2BCouponStatus = async (couponId, status) => {
  return apiCall(`${API_BASE_URL}/b2b/coupon/toggleCoupon`, {
    method: 'POST',
    body: JSON.stringify({ status, couponId }),
  });
};

// Coupon management API functions
export const getCoupons = async (filters = {}) => {
  const queryParams = new URLSearchParams();
  
  // Add all filter parameters
  Object.keys(filters).forEach(key => {
    console.log("key is ", key);
    if (filters[key] && filters[key] !== 'all') {
      queryParams.append(key, filters[key]);
    }
  });
  
  const url = queryParams.toString() ? `${API_ENDPOINTS.COUPONS}?${queryParams}` : API_ENDPOINTS.COUPONS;
  return apiCall(url);
};

export const getCouponDetail = async (couponId) => {
  return apiCall(API_ENDPOINTS.COUPON_DETAIL(couponId));
};

export const createCoupon = async (couponData) => {
  return apiCall(API_ENDPOINTS.CREATE_COUPON, {
    method: 'POST',
    body: JSON.stringify(couponData),
  });
};

export const toggleCouponStatus = async (couponId, status) => {
  return apiCall(API_ENDPOINTS.TOGGLE_COUPON_STATUS(couponId), {
    method: 'POST',
    body: JSON.stringify({ status, couponId }),
  });
};

export const updateWarehouseSettings = async (productId, warehouseIds, settings) => {
  const token = localStorage.getItem('authToken');
  return apiCall(API_ENDPOINTS.UPDATE_WAREHOUSE_SETTINGS, {
    method: 'POST',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify({
      productId,
      warehouseIds,
      ...settings
    }),
  });
};

// Virtual (pre-order) inventory batches for a product in a hub.
export const getVirtualInventory = async (productId, warehouseId) => {
  return apiCall(`${API_BASE_URL}/warehouses/virtual-inventory?productId=${enc(productId)}&warehouseId=${enc(warehouseId)}`);
};

export const updateVirtualInventory = async (productId, warehouseIds, batches) => {
  return apiCall(`${API_BASE_URL}/warehouses/virtual-inventory`, {
    method: 'POST',
    body: JSON.stringify({ productId, warehouseIds, batches }),
  });
};

export const getWarehouses = async () => {
  return apiCall(API_ENDPOINTS.GET_WAREHOUSES);
};

// VBA management API functions
export const getAllVBAs = async () => {
  return apiCall(API_ENDPOINTS.VBA_ALL);
};

export const getVBAPayments = async (virtualAccountId) => {
  return apiCall(API_ENDPOINTS.VBA_PAYMENTS(virtualAccountId));
};

export const updateDetailAndCreateVBA = async (phone, name, email) => {
  return apiCall(`${API_BASE_URL}/vba/oms/updateDetailAndCreateVBA`, {
    method: 'POST',
    body: JSON.stringify({ phone, name, email }),
  });
};

export const checkUserByPhone = async (phone) => {
  return apiCall(`${API_BASE_URL}/vba/oms/checkUserByPhone?phone=${enc(phone)}`);
};

export const updateOrderDetails = async (orderId, updateData) => {
  return apiCall(`${API_BASE_URL}/orders/oms/updateOrderDetails?orderId=${enc(orderId)}`, {
    method: 'PUT',
    body: JSON.stringify(updateData),
  });
};

export const updateItemSerialNumbers = async (orderItemId, serialNumbers, dcrStatus) => {
  return apiCall(`${API_BASE_URL}/orders/oms/updateSerialNumbers`, {
    method: 'POST',
    body: JSON.stringify({ orderItemId, serialNumbers, ...(dcrStatus && { dcrStatus }) }),
  });
};

export const updateKitItemSerialNumbers = async (kitItemId, serialNumbers) => {
  return apiCall(`${API_BASE_URL}/orders/oms/updateKitItemSerialNumbers`, {
    method: 'POST',
    body: JSON.stringify({ kitItemId, serialNumbers }),
  });
}; 

export const downloadDraftInvoice = async (orderId) => {
  const token = localStorage.getItem('authToken');
  
  const response = await fetch(`${API_BASE_URL}/invoices/draft/${enc(orderId)}`, {
    method: 'GET',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return;
  }

  // Check if response is JSON (error) or blob (file)
  const contentType = response.headers.get('content-type');
  
  if (contentType && contentType.includes('application/json')) {
    // It's an error response
    const errorData = await response.json();
    throw { response: { data: errorData } };
  }

  if (!response.ok) {
    throw new Error('Failed to download invoice');
  }

  // Get filename from content-disposition header
  const contentDisposition = response.headers.get('content-disposition');
  let filename = `draft_invoice_${orderId}.pdf`;
  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
    if (filenameMatch) {
      filename = filenameMatch[1];
    }
  }

  // Create blob and download
  const blob = await response.blob();
  await saveBlob(blob, filename);
  
  return { success: true, message: 'Invoice downloaded successfully' };
};

export const sendOrderWhatsAppTrigger = async (orderId) => {
  const token = localStorage.getItem('authToken');
  return apiCall(`${API_BASE_URL}/invoices/draft/invoiceTrigger`, {
    method: 'POST',
    body: JSON.stringify({ orderId, token }),
  });
};



export const getPendingActions = async (filters = {}) => {
  const queryParams = new URLSearchParams();
  
  if (filters.order_id) {
    queryParams.append('order_id', filters.order_id);
  }
  
  if (filters.action_type) {
    queryParams.append('action_type', filters.action_type);
  }

  if (filters.warehouse_id) {
    queryParams.append('warehouse_id', filters.warehouse_id);
  }
  
  const url = `${API_BASE_URL}/pending-actions/pending-actions${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  return apiCall(url);
};

export const getPendingActionTypes = async () => {
  return apiCall(`${API_BASE_URL}/pending-actions/pending-actions/types`);
};

export const getPendingActionsSummary = async () => {
  return apiCall(`${API_BASE_URL}/pending-actions/pending-actions/summary`);
};

export const getProductPricingHistory = async (productId, warehouseId, filters = {}) => {
  const queryParams = new URLSearchParams();
  
  if (warehouseId) {
    queryParams.append('hub_id', warehouseId);
  }
  
  if (filters.start_date) {
    queryParams.append('start_date', filters.start_date);
  }
  
  if (filters.end_date) {
    queryParams.append('end_date', filters.end_date);
  }
  
  if (filters.page) {
    queryParams.append('page', filters.page);
  }
  
  if (filters.limit) {
    queryParams.append('limit', filters.limit);
  }
  
  const url = `${API_BASE_URL}/pricing-history/product/${enc(productId)}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  return apiCall(url);
};

export const getSerialDCRRegister = async (params = {}) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== '') q.append(k, v); });
  return apiCall(`${API_BASE_URL}/orders/oms/serial-dcr-register?${q.toString()}`);
};

export const exportSerialDCRRegister = async (params = {}) => {
  const token = localStorage.getItem('authToken');
  const q = new URLSearchParams();
  const exportFilters = ['dateFrom', 'dateTo', 'warehouseId', 'dcrStatus', 'format'];
  exportFilters.forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== '') q.append(key, value);
  });
  const response = await fetch(`${API_BASE_URL}/orders/oms/serial-dcr-register/export?${q.toString()}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) throw new Error('Export failed');
  const blob = await response.blob();
  const ext = params.format === 'xlsx' ? 'xlsx' : 'csv';
  await saveBlob(blob, `serial-dcr-register.${ext}`);
};

/**
 * GET /whatsapp/queue-status
 * Response: { data: { sentToday, queued, estimatedSendTime, dailyLimit, hourlyLimit } }
 */
export const getWhatsAppQueueStatus = async () => {
  return apiCall(`${API_BASE_URL}/whatsapp/queue-status`);
};

/**
 * POST /whatsapp/broadcast
 * Body: {
 *   dryRun: boolean,
 *   mode: 'clients' | 'csv',
 *   message: string,
 *   // mode === 'clients':
 *   cutoffDate: string (ISO date, optional),
 *   hubs: string[] (optional, empty = all),
 *   // mode === 'csv':
 *   csvNumbers: string[],   // normalised to 91XXXXXXXXXX
 *   groupPreferred: boolean,
 *   batchSize: number,
 * }
 * Response (dryRun=true, mode=clients): { data: { matched, withGroup } }
 * Response (dryRun=true, mode=csv):     { data: { withGroup } }
 * Response (dryRun=false):              { data: { campaignId, totalRecipients, sentCount, queuedCount } }
 */
export const sendWhatsAppBroadcast = async (payload) => {
  return apiCall(`${API_BASE_URL}/whatsapp/broadcast`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

/**
 * GET /whatsapp/broadcast/history
 * Response: { data: Array<{
 *   id, createdAt, adminName, filterCriteria, csvName,
 *   message, totalRecipients, sentCount, queuedCount, failedCount
 * }> }
 */
export const getWhatsAppBroadcastHistory = async () => {
  return apiCall(`${API_BASE_URL}/whatsapp/broadcast/history`);
};

// ─── Promotional WhatsApp (Baileys, open-source sender) ───────────────────────

/** GET /whatsapp/promotional/status — connection state. */
export const getPromoWhatsAppSessions = async () =>
  apiCall(`${API_BASE_URL}/whatsapp/promotional/sessions`);

/** POST /whatsapp/promotional/sessions — add a new number (fresh QR). */
export const createPromoWhatsAppSession = async (label) =>
  apiCall(`${API_BASE_URL}/whatsapp/promotional/sessions`, {
    method: 'POST',
    body: JSON.stringify({ label }),
  });

/** GET /whatsapp/promotional/sessions/:id/qr — latest QR + status for a number. */
export const getPromoWhatsAppSessionQr = async (sessionId) =>
  apiCall(`${API_BASE_URL}/whatsapp/promotional/sessions/${enc(sessionId)}/qr`);

/** POST /whatsapp/promotional/sessions/:id/logout — unlink a number. */
export const logoutPromoWhatsAppSession = async (sessionId) =>
  apiCall(`${API_BASE_URL}/whatsapp/promotional/sessions/${enc(sessionId)}/logout`, { method: 'POST' });

/**
 * POST /whatsapp/promotional/send
 * Body: { sessionId, message, phones?: string[], userIds?: (number|string)[] }
 */
export const sendPromoWhatsApp = async (payload) =>
  apiCall(`${API_BASE_URL}/whatsapp/promotional/send`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

/** GET /whatsapp/promotional/logs — recent promotional send history. */
export const getPromoWhatsAppLogs = async (filters = {}) => {
  const q = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => { if (v) q.append(k, v); });
  return apiCall(`${API_BASE_URL}/whatsapp/promotional/logs${q.toString() ? '?' + q.toString() : ''}`);
};

/**
 * GET /whatsapp/message-log?orderId=&type=&status=
 * Response: { data: Array<{
 *   timestamp, orderId, messageType, groupId, status ('sent'|'failed'|'no_group')
 * }> }
 */
export const getWhatsAppMessageLog = async (filters = {}) => {
  const q = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => { if (v) q.append(k, v); });
  return apiCall(`${API_BASE_URL}/whatsapp/logs${q.toString() ? '?' + q.toString() : ''}`);
};

export const getLiveWhatsAppMessages = async ({ limit = 200, offset = 0 } = {}) => {
  const q = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });
  return apiCall(`${API_ENDPOINTS.LIVE_WHATSAPP_MESSAGES}?${q.toString()}`);
};

export const getLiveWhatsAppChats = async ({ limit = 50, offset = 0, search = '', type = 'all' } = {}) => {
  const q = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });
  if (search.trim()) q.set('q', search.trim());
  if (type !== 'all') q.set('type', type);
  return apiCall(`${API_ENDPOINTS.LIVE_WHATSAPP_CHATS}?${q.toString()}`);
};

export const getLiveWhatsAppChatMessages = async (chatId, { limit = 100, offset = 0 } = {}) => {
  const q = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });
  return apiCall(`${API_ENDPOINTS.LIVE_WHATSAPP_CHAT_MESSAGES(chatId)}?${q.toString()}`);
};

export const sendLiveWhatsAppChatMessage = async (chatId, { message, requestId }) => {
  return apiCall(API_ENDPOINTS.LIVE_WHATSAPP_CHAT_MESSAGES(chatId), {
    method: 'POST',
    body: JSON.stringify({ message, requestId }),
  });
};

export const streamLiveWhatsAppMessages = async ({ signal, onMessage, onReady }) => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(API_ENDPOINTS.LIVE_WHATSAPP_STREAM, {
    signal,
    headers: {
      Accept: 'text/event-stream',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return;
  }
  if (!response.ok || !response.body) {
    throw new Error(`Unable to connect to live WhatsApp stream (${response.status})`);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true }).replace(/\r\n/g, '\n');
      const events = buffer.split('\n\n');
      buffer = events.pop() || '';

      events.forEach((block) => {
        if (!block || block.startsWith(':')) return;

        let eventName = 'message';
        const data = [];
        block.split('\n').forEach((line) => {
          if (line.startsWith('event:')) eventName = line.slice(6).trim();
          if (line.startsWith('data:')) data.push(line.slice(5).trimStart());
        });
        if (!data.length) return;

        try {
          const parsed = JSON.parse(data.join('\n'));
          if (eventName === 'ready') onReady?.(parsed);
          if (eventName === 'message') onMessage?.(parsed);
        } catch (_) {
          // Ignore malformed upstream events and keep the stream connected.
        }
      });
    }
  } finally {
    reader.releaseLock();
  }
};

// export const updateSerialNumbers = async (rowId, serialNumbers) => {
//   return apiCall(API_ENDPOINTS.DCR_UPDATE_SERIAL(rowId), {
//     method: 'PUT',
//     body: JSON.stringify({ serialNumbers }),
//   });
// };


export const getPricingChangeHistory = async (productId, warehouseId, limit = 50) => {
  const queryParams = new URLSearchParams();
  queryParams.append('productId', productId);
  queryParams.append('warehouseId', warehouseId);
  queryParams.append('limit', limit);

  const url = `${API_BASE_URL}/pricing-change-logs/history?${queryParams.toString()}`;
  return apiCall(url);
};

// Hub Management API functions
export const getHubs = () => apiCall(API_ENDPOINTS.GET_HUBS);
export const getHubSettings = (hubId) => apiCall(API_ENDPOINTS.GET_HUB_SETTINGS(hubId));
export const updateHubGeneral = (hubId, data) => apiCall(API_ENDPOINTS.UPDATE_HUB_GENERAL(hubId), { method: 'PUT', body: JSON.stringify(data) });
export const updateHubDeliveryFees = (hubId, data) => apiCall(API_ENDPOINTS.UPDATE_HUB_DELIVERY_FEES(hubId), { method: 'PUT', body: JSON.stringify(data) });
export const updateHubHandlingCharges = (hubId, data) => apiCall(API_ENDPOINTS.UPDATE_HUB_HANDLING_CHARGES(hubId), { method: 'PUT', body: JSON.stringify(data) });
export const getHubPincodes = (hubId) => apiCall(API_ENDPOINTS.GET_HUB_PINCODES(hubId));
export const addHubPincode = (hubId, pincode) => apiCall(API_ENDPOINTS.ADD_HUB_PINCODE(hubId), { method: 'POST', body: JSON.stringify({ pincode }) });
export const removeHubPincode = (hubId, pincode) => apiCall(API_ENDPOINTS.REMOVE_HUB_PINCODE(hubId), { method: 'POST', body: JSON.stringify({ pincode }) });
export const togglePincodeFarArea = (hubId, pincode, isFar) => apiCall(API_ENDPOINTS.TOGGLE_PINCODE_FAR_AREA(hubId), { method: 'POST', body: JSON.stringify({ pincode, isFar }) });
export const searchHubPincode = (pincode) => apiCall(API_ENDPOINTS.SEARCH_HUB_PINCODE(pincode));

export const getOmsDealsBanners = () => apiCall(API_ENDPOINTS.OMS_DEALS_BANNERS);

// Gift product config (marketing)
export const getGiftConfig = () => apiCall(API_ENDPOINTS.OMS_GIFT_CONFIG);
export const updateGiftConfig = (sku) =>
  apiCall(API_ENDPOINTS.OMS_GIFT_CONFIG, { method: 'PUT', body: JSON.stringify({ sku }) });
export const deleteDealsBanner = (bannerId) => apiCall(`${API_ENDPOINTS.OMS_DEALS_BANNERS}/${enc(bannerId)}/delete`, { method: 'POST' });
export const createDealsBanner = async (bannerData) => {
  const token = localStorage.getItem('authToken');
  const formData = new FormData();
  Object.entries(bannerData).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      formData.append(key, key === 'warehouseIds' ? JSON.stringify(value) : value);
    }
  });

  const response = await fetch(API_ENDPOINTS.OMS_DEALS_BANNERS, {
    method: 'POST',
    headers: { ...(token && { Authorization: `Bearer ${token}` }) },
    body: formData,
  });

  if (response.status === 401 || response.status === 403) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return;
  }

  const result = await response.json().catch(() => ({}));
  if (!response.ok || !result.success) {
    throw new Error(result.message || 'Failed to create banner');
  }

  return result.data;
};

// Brand Support API functions
export const getBrandSupports = () => apiCall(API_ENDPOINTS.BRAND_SUPPORT_LIST);
export const createBrandSupport = (data) => apiCall(API_ENDPOINTS.BRAND_SUPPORT_CREATE, { method: 'POST', body: JSON.stringify(data) });
export const updateBrandSupport = (id, data) => apiCall(API_ENDPOINTS.BRAND_SUPPORT_UPDATE(id), { method: 'PUT', body: JSON.stringify(data) });
export const deleteBrandSupport = (id) => apiCall(API_ENDPOINTS.BRAND_SUPPORT_DELETE(id), { method: 'DELETE' });

// Invoice management API functions
export const createInvoiceRequest = async (orderId) => {
  return apiCall(`${API_BASE_URL}/gstzen-invoices/requests`, {
    method: 'POST',
    body: JSON.stringify({ orderId }),
  });
};

export const getInvoiceRequests = async (status = null) => {
  const queryParams = new URLSearchParams();
  if (status) {
    queryParams.append('status', status);
  }
  const url = `${API_BASE_URL}/gstzen-invoices/requests${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  return apiCall(url);
};

export const generateInvoiceViaGSTZen = async (orderId, invoiceNumber = null, options = {}) => {
  const payload = { orderId };
  // Invoice number is auto-generated on the backend; only send if explicitly provided.
  if (invoiceNumber) payload.invoiceNumber = invoiceNumber;
  // `direct` lets Hub Manager access users generate without the request/approve step.
  if (options.direct) payload.direct = true;
  return apiCall(`${API_BASE_URL}/gstzen-invoices/generate`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

export const getGeneratedInvoices = async (filters = {}) => {
  const queryParams = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => { if (v) queryParams.append(k, v); });
  const url = `${API_BASE_URL}/gstzen-invoices/generated${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  return apiCall(url);
};

// Intrastate hub-to-hub: generate a Delivery Challan (no tax invoice).
export const generateDeliveryChallan = async (orderId) => {
  return apiCall(`${API_BASE_URL}/gstzen-invoices/generate-dc`, {
    method: 'POST',
    body: JSON.stringify({ orderId }),
  });
};

// Generate the e-way bill for a Delivery Challan (intrastate hub-to-hub).
export const generateDeliveryChallanEwayBill = async (invoiceId, distance = null, transporterName = null) => {
  const body = {};
  if (distance) body.distance = +distance;
  if (transporterName) body.transporterName = transporterName;
  return apiCall(`${API_BASE_URL}/gstzen-invoices/${enc(invoiceId)}/generate-dc-eway`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getPromoConsumptionsByOrder = async (orderId) => {
  return apiCall(`${API_BASE_URL}/promo-wallet/consumptions/order/${enc(orderId)}`);
};

export const getInvoiceLedger = async (filters = {}) => {
  const queryParams = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => { if (v !== undefined && v !== '') queryParams.append(k, v); });
  const url = `${API_BASE_URL}/gstzen-invoices/ledger${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  return apiCall(url);
};

export const getGstDetails = async (filters = {}) => {
  const queryParams = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== '') queryParams.append(key, value);
  });
  const url = `${API_BASE_URL}/gst/details${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  return apiCall(url);
};

export const getGstB2B = async (filters = {}) => {
  const queryParams = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== '') queryParams.append(key, value);
  });
  const url = `${API_BASE_URL}/gst/b2b${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  return apiCall(url);
};

export const getGstB2BSezDe = async (filters = {}) => {
  const queryParams = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== '') queryParams.append(key, value);
  });
  const url = `${API_BASE_URL}/gst/b2b-sez-de${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  return apiCall(url);
};

export const getGstCDNR = async (filters = {}) => {
  const queryParams = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== '') queryParams.append(key, value);
  });
  const url = `${API_BASE_URL}/gst/cdnr${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  return apiCall(url);
};

export const getGstHSN12 = async (filters = {}) => {
  const queryParams = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== '') queryParams.append(key, value);
  });
  const url = `${API_BASE_URL}/gst/hsn12${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  return apiCall(url);
};

export const getGstDocs13 = async (filters = {}) => {
  const queryParams = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== '') queryParams.append(key, value);
  });
  const url = `${API_BASE_URL}/gst/docs13${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  return apiCall(url);
};

export const uploadManualInvoice = async (orderId, file = null, ewayBillFile = null, ledgerItems = [], type = 'invoice') => {
  const token = localStorage.getItem('authToken');
  const formData = new FormData();
  formData.append('orderId', orderId);
  formData.append('type', type);
  if (file) formData.append('file', file);
  if (ewayBillFile) formData.append('eway_bill', ewayBillFile);
  if (ledgerItems.length > 0) formData.append('ledgerItems', JSON.stringify(ledgerItems));

  const response = await fetch(`${API_BASE_URL}/gstzen-invoices/upload-manual`, {
    method: 'POST',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: formData,
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return;
  }

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData?.message || `HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const uploadInvoiceFile = async (invoiceId, file) => {
  const token = localStorage.getItem('authToken');
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(`${API_BASE_URL}/gstzen-invoices/${enc(invoiceId)}/upload-invoice-file`, {
    method: 'POST',
    headers: { ...(token && { Authorization: `Bearer ${token}` }) },
    body: formData,
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return;
  }

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData?.message || `HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const getInvoiceDownloadUrl = async (invoiceId) => {
  return apiCall(`${API_BASE_URL}/gstzen-invoices/${enc(invoiceId)}/download-url`);
};

export const getEwayBillDownloadUrl = async (invoiceId) => {
  return apiCall(`${API_BASE_URL}/gstzen-invoices/${enc(invoiceId)}/eway-bill-url`);
};

export const generateEwayBill = async (invoiceId, distance = null, transporterName = null) => {
  const body = {};
  if (distance) body.distance = +distance;
  if (transporterName) body.transporterName = transporterName;
  return apiCall(`${API_BASE_URL}/gstzen-invoices/${enc(invoiceId)}/generate-eway-bill`, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json' } });
};

export const uploadEwayBill = async (invoiceId, file) => {
  const token = localStorage.getItem('authToken');
  const formData = new FormData();
  formData.append('eway_bill', file);

  const response = await fetch(`${API_BASE_URL}/gstzen-invoices/${enc(invoiceId)}/upload-eway-bill`, {
    method: 'POST',
    headers: { ...(token && { Authorization: `Bearer ${token}` }) },
    body: formData,
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return;
  }

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData?.message || `HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const requestInvoiceCancellation = async (invoiceId) => {
  return apiCall(`${API_BASE_URL}/gstzen-invoices/${enc(invoiceId)}/request-cancellation`, {
    method: 'POST',
  });
};

export const approveInvoiceCancellation = async (invoiceId) => {
  return apiCall(`${API_BASE_URL}/gstzen-invoices/${enc(invoiceId)}/approve-cancellation`, {
    method: 'POST',
  });
};

export const rejectInvoiceCancellation = async (invoiceId) => {
  return apiCall(`${API_BASE_URL}/gstzen-invoices/${enc(invoiceId)}/reject-cancellation`, {
    method: 'POST',
  });
};

// Unified transaction history (ledger + promo wallet)
export const getUnifiedTransactionHistory = async (phone, page = 1, limit = 50, userId = '') => {
  const queryParams = new URLSearchParams();
  if (phone) queryParams.append('phone', phone);
  if (userId) queryParams.append('user_id', userId);
  queryParams.append('page', page);
  queryParams.append('limit', limit);
  
  const url = `${API_BASE_URL}/ledger/unified-history/oms?${queryParams}`;
  return apiCall(url);
};

// Order History
export const getOrderHistory = async (orderId) => {
  return apiCall(`${API_BASE_URL}/orders/oms/order-history?orderId=${enc(orderId)}`);
};

// Adjust delivery fee (remove/add)
export const adjustDeliveryFee = async (orderId, action, amount = 0) => {
  return apiCall(`${API_BASE_URL}/orders/oms/adjustDeliveryFee`, {
    method: 'POST',
    body: JSON.stringify({ orderId, action, amount }),
  });
};

// ─── Custom Kits API ──────────────────────────────────────────────────────────

export const createKit = async (kitData, imageFile) => {
  const token = localStorage.getItem('authToken');
  const formData = new FormData();
  formData.append('name', kitData.name);
  formData.append('category_id', kitData.category_id || 4);
  if (kitData.discount_percent) formData.append('discount_percent', kitData.discount_percent);
  if (kitData.gst_percent) formData.append('gst_percent', kitData.gst_percent);
  if (kitData.hsn_code) formData.append('hsn_code', kitData.hsn_code);
  if (kitData.tags) formData.append('tags', kitData.tags);
  formData.append('min_optional_count', kitData.min_optional_count || 0);
  if (kitData.warehouse_id) formData.append('warehouse_id', kitData.warehouse_id);
  if (kitData.description) formData.append('description', kitData.description);
  if (kitData.variants) formData.append('variants', JSON.stringify(kitData.variants));
  formData.append('categories', JSON.stringify(kitData.categories));
  if (imageFile) formData.append('image', imageFile);

  const response = await fetch(`${API_BASE_URL}/kits/create`, {
    method: 'POST',
    headers: { ...(token && { Authorization: `Bearer ${token}` }) },
    body: formData,
  });
  if (response.status === 401) { localStorage.removeItem('authToken'); window.location.href = '/login'; return; }
  if (!response.ok) { const err = await response.json().catch(() => ({})); throw new Error(err.message || 'Failed to create kit'); }
  return response.json();
};

export const createKitBulk = async (kitData, imageFile) => {
  const token = localStorage.getItem('authToken');
  const formData = new FormData();
  formData.append('name', kitData.name);
  formData.append('category_id', kitData.category_id || 4);
  if (kitData.discount_percent) formData.append('discount_percent', kitData.discount_percent);
  if (kitData.gst_percent) formData.append('gst_percent', kitData.gst_percent);
  if (kitData.hsn_code) formData.append('hsn_code', kitData.hsn_code);
  if (kitData.tags) formData.append('tags', kitData.tags);
  formData.append('min_optional_count', kitData.min_optional_count || 0);
  if (kitData.warehouse_ids) formData.append('warehouse_ids', JSON.stringify(kitData.warehouse_ids));
  if (kitData.description) formData.append('description', kitData.description);
  if (kitData.variants) formData.append('variants', JSON.stringify(kitData.variants));
  formData.append('categories', JSON.stringify(kitData.categories));
  if (imageFile) formData.append('image', imageFile);

  const response = await fetch(`${API_BASE_URL}/kits/create-bulk`, {
    method: 'POST',
    headers: { ...(token && { Authorization: `Bearer ${token}` }) },
    body: formData,
  });
  if (response.status === 401) { localStorage.removeItem('authToken'); window.location.href = '/login'; return; }
  if (!response.ok) { const err = await response.json().catch(() => ({})); throw new Error(err.message || 'Failed to create kit in bulk'); }
  return response.json();
};

export const updateKit = async (kitId, kitData, imageFile) => {
  const token = localStorage.getItem('authToken');
  const formData = new FormData();
  if (kitData.name !== undefined) formData.append('name', kitData.name);
  if (kitData.discount_percent !== undefined) formData.append('discount_percent', kitData.discount_percent);
  if (kitData.gst_percent !== undefined) formData.append('gst_percent', kitData.gst_percent);
  if (kitData.hsn_code !== undefined) formData.append('hsn_code', kitData.hsn_code);
  if (kitData.tags !== undefined) formData.append('tags', kitData.tags);
  if (kitData.min_optional_count !== undefined) formData.append('min_optional_count', kitData.min_optional_count);
  if (kitData.warehouse_id !== undefined) formData.append('warehouse_id', kitData.warehouse_id);
  if (kitData.description !== undefined) formData.append('description', kitData.description);
  if (kitData.variants !== undefined) formData.append('variants', JSON.stringify(kitData.variants));
  if (kitData.categories) formData.append('categories', JSON.stringify(kitData.categories));
  if (imageFile) formData.append('image', imageFile);

  const response = await fetch(`${API_BASE_URL}/kits/update/${enc(kitId)}`, {
    method: 'PUT',
    headers: { ...(token && { Authorization: `Bearer ${token}` }) },
    body: formData,
  });
  if (response.status === 401) { localStorage.removeItem('authToken'); window.location.href = '/login'; return; }
  if (!response.ok) { const err = await response.json().catch(() => ({})); throw new Error(err.message || 'Failed to update kit'); }
  return response.json();
};

export const updateKitBulk = async (batchId, kitData, imageFile) => {
  const token = localStorage.getItem('authToken');
  const formData = new FormData();
  if (kitData.warehouse_ids) formData.append('warehouse_ids', JSON.stringify(kitData.warehouse_ids));
  if (kitData.name !== undefined) formData.append('name', kitData.name);
  if (kitData.discount_percent !== undefined) formData.append('discount_percent', kitData.discount_percent);
  if (kitData.gst_percent !== undefined) formData.append('gst_percent', kitData.gst_percent);
  if (kitData.hsn_code !== undefined) formData.append('hsn_code', kitData.hsn_code);
  if (kitData.tags !== undefined) formData.append('tags', kitData.tags);
  if (kitData.min_optional_count !== undefined) formData.append('min_optional_count', kitData.min_optional_count);
  if (kitData.description !== undefined) formData.append('description', kitData.description);
  if (kitData.variants !== undefined) formData.append('variants', JSON.stringify(kitData.variants));
  if (kitData.categories) formData.append('categories', JSON.stringify(kitData.categories));
  if (imageFile) formData.append('image', imageFile);

  const response = await fetch(`${API_BASE_URL}/kits/update-bulk/${enc(batchId)}`, {
    method: 'PUT',
    headers: { ...(token && { Authorization: `Bearer ${token}` }) },
    body: formData,
  });
  if (response.status === 401) { localStorage.removeItem('authToken'); window.location.href = '/login'; return; }
  if (!response.ok) { const err = await response.json().catch(() => ({})); throw new Error(err.message || 'Failed to update kit for selected warehouses'); }
  return response.json();
};

export const getKitDetail = async (kitId) => {
  return apiCall(`${API_BASE_URL}/kits/detail/${enc(kitId)}`);
};

export const getBatchWarehouses = async (batchId) => {
  return apiCall(`${API_BASE_URL}/kits/batch/${enc(batchId)}/warehouses`);
};

export const getKitsList = async (warehouseId) => {
  const queryParams = new URLSearchParams();
  if (warehouseId) queryParams.append('warehouseId', warehouseId);
  const url = `${API_BASE_URL}/kits/list${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  return apiCall(url);
};

export const toggleKitStatus = async (kitId) => {
  return apiCall(`${API_BASE_URL}/kits/toggle`, {
    method: 'POST',
    body: JSON.stringify({ kitId }),
  });
};

// ─── Audience Module API ──────────────────────────────────────────────────────────

export const getAudiencesList = async (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.search) queryParams.append('search', params.search);
  if (params.type) queryParams.append('type', params.type);
  if (params.status) queryParams.append('status', params.status);
  const url = `${API_BASE_URL}/audiences${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  return apiCall(url);
};

export const getAudienceDetail = async (id, params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.start_date) queryParams.append('start_date', params.start_date);
  if (params.end_date) queryParams.append('end_date', params.end_date);
  const url = `${API_BASE_URL}/audiences/${enc(id)}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  return apiCall(url);
};

export const previewAudience = async (filters) => {
  return apiCall(`${API_BASE_URL}/audiences/preview`, {
    method: 'POST',
    body: JSON.stringify({ filters }),
  });
};

export const createAudience = async (audienceData) => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_BASE_URL}/audiences`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify(audienceData),
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return;
  }

  let data;
  try {
    data = await response.json();
  } catch {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  if (!response.ok) {
    if (data.requires_confirmation) {
      const err = new Error(data.message || 'Confirmation required');
      err.requires_confirmation = true;
      err.responseData = data;
      throw err;
    }
    throw new Error(data.message || data.error || `HTTP error! status: ${response.status}`);
  }

  return data;
};

export const refreshAudience = async (id, { confirm } = {}) => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_BASE_URL}/audiences/${enc(id)}/refresh`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify(confirm ? { confirm: true } : {}),
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return;
  }

  let data;
  try {
    data = await response.json();
  } catch {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  if (!response.ok) {
    if (data.requires_confirmation) {
      const err = new Error(data.message || 'Confirmation required');
      err.requires_confirmation = true;
      err.responseData = data;
      throw err;
    }
    throw new Error(data.message || data.error || `HTTP error! status: ${response.status}`);
  }

  return data;
};

export const archiveAudience = async (id) => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_BASE_URL}/audiences/${enc(id)}/archive`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return;
  }

  let data;
  try {
    data = await response.json();
  } catch {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return {};
  }

  if (!response.ok) {
    const err = new Error(data.message || data.error || `HTTP error! status: ${response.status}`);
    err.status = response.status;
    err.responseData = data;
    throw err;
  }

  return data;
};

export const getAudienceTemplates = async () => {
  return apiCall(`${API_BASE_URL}/audiences/templates`);
};

export const exportAudienceCsv = async (id) => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_BASE_URL}/audiences/${enc(id)}/members`, {
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return;
  }

  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || `Export failed (${response.status})`);
  }

  const blob = await response.blob();
  await saveBlob(blob, `audience-members-${id}.csv`);
};

export const uploadAudienceUsers = async (file) => {
  const token = localStorage.getItem('authToken');
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(`${API_BASE_URL}/audiences/upload-users`, {
    method: 'POST',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: formData,
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return;
  }

  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || `Upload failed (${response.status})`);
  }

  return response.json();
};

export const exportAudienceMessaging = async (id, channel) => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_BASE_URL}/audiences/${enc(id)}/export-messaging?channel=${encodeURIComponent(channel)}`, {
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return;
  }

  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || `Export failed (${response.status})`);
  }

  const totalExported = response.headers.get('X-Total-Exported');
  const removedOptouts = response.headers.get('X-Removed-Optouts');

  const blob = await response.blob();
  await saveBlob(blob, `audience-${id}-${channel}.csv`);

  return { totalExported, removedOptouts };
};

export const bulkCreditByAudience = async (payload) => {
  return apiCall(`${API_BASE_URL}/promo-wallet/bulk-credit-audience`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

// ─── CRM — Lead Management API ────────────────────────────────────────────────

// Paginated, filterable list of leads. Phone numbers are never returned here.
export const getCrmLeads = async (filters = {}) => {
  const queryParams = new URLSearchParams();
  Object.keys(filters).forEach((key) => {
    const value = filters[key];
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== '' && item !== 'all') {
          queryParams.append(key, item);
        }
      });
    } else if (value !== undefined && value !== '' && value !== 'all') {
      queryParams.append(key, value);
    }
  });
  const url = queryParams.toString()
    ? `${API_ENDPOINTS.CRM_LEADS}?${queryParams}`
    : API_ENDPOINTS.CRM_LEADS;
  return apiCall(url);
};

export const getCrmLeadDetail = async (leadId) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_DETAIL(leadId));
};

export const getCrmHistory = async (filters = {}) => {
  const query = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.append(key, value);
  });
  const suffix = query.toString() ? `?${query.toString()}` : '';
  return apiCall(`${API_ENDPOINTS.CRM_HISTORY}${suffix}`);
};

export const archiveCrmLead = async (leadId) => {
  return setCrmLeadArchived(leadId, true);
};

export const setCrmLeadArchived = async (leadId, archived) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_ARCHIVE(leadId), {
    method: 'PATCH',
    body: JSON.stringify({ archived: Boolean(archived) }),
  });
};

export const deleteCrmLead = async (leadId) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_DELETE(leadId), {
    method: 'DELETE',
  });
};

export const getCrmLeadTimeline = async (leadId, filters = {}) => {
  const query = new URLSearchParams(filters);
  return apiCall(`${API_ENDPOINTS.CRM_LEAD_TIMELINE(leadId)}?${query}`);
};

// Create a new lead (created_from = manual). Enforces phone/GST uniqueness
// server-side; a 409 response names the lead that already holds the value.
export const createCrmLead = async (payload) => {
  return apiCall(API_ENDPOINTS.CRM_LEADS, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

// Trigger a masked click-to-call. The backend rings the agent, then bridges
// the contact; the contact's number is never sent to the client.
export const initiateCrmCall = async (
  leadId,
  { contactId, hubId, hubNumber, provider, mode, orderId } = {}
) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_CALL(leadId), {
    method: 'POST',
    body: JSON.stringify({ contactId, hubId, hubNumber, provider, mode, orderId }),
  });
};

export const logCrmDisposition = async (leadId, callId, data) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_DISPOSITION(leadId, callId), {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

export const logCrmQuickDisposition = async (leadId, data) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_QUICK_DISPOSITION(leadId), {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

export const addCrmLeadComment = async (leadId, comment, followUpDate = '') => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_COMMENTS(leadId), {
    method: 'POST',
    body: JSON.stringify({
      comment,
      ...(followUpDate ? { followUpDate } : {}),
    }),
  });
};

export const completeCrmVideoCallRequest = async (leadId, requestId) => {
  return apiCall(API_ENDPOINTS.CRM_VIDEO_CALL_REQUEST_STATUS(leadId, requestId), {
    method: 'PATCH',
    body: JSON.stringify({ status: 'completed' }),
  });
};

export const sendCrmLeadWhatsapp = async (leadId, payload) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_WHATSAPP(leadId), {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

// WhatsApp conversation list for a lead (one entry per contact, with last
// message + unread count).
export const getCrmLeadConversations = async (leadId) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_CONVERSATIONS(leadId));
};

// CRM Dashboard (manager/superAdmin). filters: { range, hubId, from, to }.
export const getCrmDashboard = async (filters = {}) => {
  const query = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.append(key, value);
  });
  const suffix = query.toString() ? `?${query.toString()}` : '';
  return apiCall(`${API_ENDPOINTS.CRM_DASHBOARD}${suffix}`);
};

export const getCrmDashboardHubs = async () => {
  return apiCall(API_ENDPOINTS.CRM_DASHBOARD_HUBS);
};

const downloadCrmWorkbook = async (url, fallbackName) => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(url, {
    headers: { ...(token && { Authorization: `Bearer ${token}` }) },
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    return;
  }
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.message || `CRM export failed (${response.status})`);
  }

  const disposition = response.headers.get('Content-Disposition') || '';
  const filenameMatch = disposition.match(/filename="?([^";]+)"?/i);
  const blob = await response.blob();
  await saveBlob(blob, filenameMatch?.[1] || fallbackName);
};

export const downloadCrmDashboardComments = async (filters = {}) => {
  const query = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.append(key, value);
  });
  const suffix = query.toString() ? `?${query.toString()}` : '';
  const currentDate = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
  return downloadCrmWorkbook(
    `${API_ENDPOINTS.CRM_DASHBOARD_COMMENT_EXPORT}${suffix}`,
    `crm-comments-${currentDate}.xlsx`
  );
};

export const downloadCrmLeadComments = async (leadId) => {
  const currentDate = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
  return downloadCrmWorkbook(
    API_ENDPOINTS.CRM_LEAD_COMMENT_EXPORT(leadId),
    `crm-comments-${leadId}-${currentDate}.xlsx`
  );
};

export const downloadCrmLeads = async (filters = {}) => {
  const query = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== '' && item !== 'all') query.append(key, item);
      });
    } else if (value !== undefined && value !== '' && value !== 'all') {
      query.append(key, value);
    }
  });
  const suffix = query.toString() ? `?${query.toString()}` : '';
  const currentDate = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
  return downloadCrmWorkbook(
    `${API_ENDPOINTS.CRM_LEADS_EXPORT}${suffix}`,
    `crm-leads-${currentDate}.xlsx`
  );
};

export const getCrmLeadTagOptions = async () => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_TAG_OPTIONS);
};

// The WhatsApp thread (oldest-first) for a single contact on a lead.
export const getCrmContactWhatsappThread = async (leadId, contactId) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_CONTACT_WHATSAPP(leadId, contactId));
};

// Mark all unread inbound messages for a contact as read.
export const markCrmContactWhatsappRead = async (leadId, contactId) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_CONTACT_WHATSAPP_READ(leadId, contactId), {
    method: 'PATCH',
  });
};

export const addCrmLeadContact = async (leadId, contact) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_CONTACTS(leadId), {
    method: 'POST',
    body: JSON.stringify(contact),
  });
};

export const updateCrmLead = async (leadId, changes) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_DETAIL(leadId), {
    method: 'PATCH',
    body: JSON.stringify(changes),
  });
};

export const updateCrmLeadStage = async (leadId, stage) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_STAGE(leadId), {
    method: 'PATCH',
    body: JSON.stringify({ stage }),
  });
};

export const updateCrmLeadContact = async (leadId, contactId, changes) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_CONTACT(leadId, contactId), {
    method: 'PATCH',
    body: JSON.stringify(changes),
  });
};

export const removeCrmLeadContact = async (leadId, contactId) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_CONTACT(leadId, contactId), {
    method: 'DELETE',
  });
};

export const addCrmLeadHubLink = async (leadId, hubId) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_HUB_LINKS(leadId), {
    method: 'POST',
    body: JSON.stringify({ hubId }),
  });
};

export const removeCrmLeadHubLink = async (leadId, hubId) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_HUB_LINK(leadId, hubId), {
    method: 'DELETE',
  });
};

export const addCrmLeadExternalId = async (leadId, externalId) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_EXTERNAL_IDS(leadId), {
    method: 'POST',
    body: JSON.stringify(externalId),
  });
};

export const removeCrmLeadExternalId = async (leadId, externalIdId) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_EXTERNAL_ID(leadId, externalIdId), {
    method: 'DELETE',
  });
};

export const searchCrmOmsUsers = async (search) => {
  const query = new URLSearchParams({ q: search });
  return apiCall(`${API_ENDPOINTS.CRM_OMS_USER_SEARCH}?${query}`);
};

export const searchCrmOrderGsts = async (search) => {
  const query = new URLSearchParams({ q: search });
  return apiCall(`${API_ENDPOINTS.CRM_ORDER_GST_SEARCH}?${query}`);
};

export const searchCrmPmsgVendors = async (search) => {
  const query = new URLSearchParams({ q: search });
  return apiCall(`${API_ENDPOINTS.CRM_PMSG_VENDOR_SEARCH}?${query}`);
};

export const mergeCrmLeads = async (leadId, data) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_MERGE(leadId), {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

export const splitCrmLead = async (leadId, data) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_SPLIT(leadId), {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

export const searchCrmAssignableStaff = async (search = '') => {
  const query = new URLSearchParams();
  if (search.trim()) query.set('q', search.trim());
  const suffix = query.toString() ? `?${query}` : '';
  return apiCall(`${API_ENDPOINTS.CRM_STAFF_SEARCH}${suffix}`);
};

export const assignCrmLead = async (leadId, assignedUserId) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_ASSIGNMENT(leadId), {
    method: 'PATCH',
    body: JSON.stringify({ assignedUserId }),
  });
};

export const bulkAssignCrmUser = async (leadIds, assignedUserId) => {
  return apiCall(API_ENDPOINTS.CRM_BULK_ASSIGNMENT, {
    method: 'POST',
    body: JSON.stringify({ leadIds, assignedUserId }),
  });
};

export const bulkAssignCrmHub = async (leadIds, hubId) => {
  return apiCall(API_ENDPOINTS.CRM_BULK_HUB_LINKS, {
    method: 'POST',
    body: JSON.stringify({ leadIds, hubId }),
  });
};

export const confirmCrmHubSuggestions = async (leadIds) => {
  return apiCall(API_ENDPOINTS.CRM_BULK_CONFIRM_HUB_SUGGESTIONS, {
    method: 'POST',
    body: JSON.stringify({ leadIds }),
  });
};

export const bulkUpdateCrmTags = async (leadIds, action, tag) => {
  return apiCall(API_ENDPOINTS.CRM_BULK_TAGS, {
    method: 'POST',
    body: JSON.stringify({ leadIds, action, tag }),
  });
};

// Admin-defined CRM variables (key, label, type, allowedValues).
export const getCrmVariables = async () => {
  return apiCall(API_ENDPOINTS.CRM_VARIABLES);
};

// Set one variable value on many leads at once. The server resolves the
// variable by id, normalises the value to its type, and writes edit history.
export const bulkSetCrmVariable = async (leadIds, variableId, value) => {
  return apiCall(API_ENDPOINTS.CRM_BULK_VARIABLE_VALUES, {
    method: 'POST',
    body: JSON.stringify({ leadIds, variableId, value }),
  });
};

export const uploadCrmVariableCsv = async (file) => {
  const token = localStorage.getItem('authToken');
  const body = new FormData();
  body.append('file', file);
  const response = await fetch(API_ENDPOINTS.CRM_VARIABLE_CSV_IMPORT, {
    method: 'POST',
    headers: { ...(token && { Authorization: `Bearer ${token}` }) },
    body,
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.success === false) {
    const error = new Error(payload.message || `Variable CSV upload failed (${response.status})`);
    error.details = payload.errors || payload.data || payload.details;
    throw error;
  }
  return payload;
};

export const uploadCrmLeadCsv = async (file, hubId = null) => {
  const token = localStorage.getItem('authToken');
  const body = new FormData();
  body.append('file', file);
  if (hubId) body.append('hub_id', String(hubId));
  const response = await fetch(API_ENDPOINTS.CRM_LEAD_CSV_IMPORT, {
    method: 'POST',
    headers: { ...(token && { Authorization: `Bearer ${token}` }) },
    body,
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.success === false) {
    const error = new Error(payload.message || `Lead CSV upload failed (${response.status})`);
    error.details = payload.errors || payload.data || payload.details;
    throw error;
  }
  return payload;
};

export const uploadCrmPmsgCsv = async (file, hubId = null) => {
  const token = localStorage.getItem('authToken');
  const body = new FormData();
  body.append('file', file);
  if (hubId) body.append('hub_id', String(hubId));
  const response = await fetch(API_ENDPOINTS.CRM_PMSG_CSV_IMPORT, {
    method: 'POST',
    headers: { ...(token && { Authorization: `Bearer ${token}` }) },
    body,
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.success === false) {
    const error = new Error(payload.message || `PMSG CSV upload failed (${response.status})`);
    error.details = payload.errors || payload.data || payload.details;
    throw error;
  }
  return payload;
};

// Update a lead's tags. Pass { tags } to replace the full set, or
// { add: [], remove: [] } to adjust incrementally. Server normalises/dedupes.
export const updateCrmLeadTags = async (leadId, payload) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_TAGS(leadId), {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
};

// Set one variable value on a single lead.
export const setCrmLeadVariable = async (leadId, variableId, value) => {
  return apiCall(API_ENDPOINTS.CRM_LEAD_VARIABLES(leadId), {
    method: 'PATCH',
    body: JSON.stringify({ variableId, value }),
  });
};

// ─── CRM — Saved filters ──────────────────────────────────────────────────────

export const getCrmSavedFilters = async () => {
  return apiCall(API_ENDPOINTS.CRM_SAVED_FILTERS);
};

export const createCrmSavedFilter = async (name, filters) => {
  return apiCall(API_ENDPOINTS.CRM_SAVED_FILTERS, {
    method: 'POST',
    body: JSON.stringify({ name, filters }),
  });
};

export const deleteCrmSavedFilter = async (id) => {
  return apiCall(API_ENDPOINTS.CRM_SAVED_FILTER_DELETE(id), {
    method: 'DELETE',
  });
};

// ─── CRM — Settings (admin only): Variables ───────────────────────────────────

export const getCrmSettingsVariables = async () => {
  return apiCall(API_ENDPOINTS.CRM_SETTINGS_VARIABLES);
};

export const createCrmVariable = async (payload) => {
  return apiCall(API_ENDPOINTS.CRM_SETTINGS_VARIABLES, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

export const updateCrmVariable = async (id, payload) => {
  return apiCall(API_ENDPOINTS.CRM_SETTINGS_VARIABLE(id), {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
};

export const deactivateCrmVariable = async (id) => {
  return apiCall(API_ENDPOINTS.CRM_SETTINGS_VARIABLE(id), {
    method: 'DELETE',
  });
};

export const getCrmDispositions = async () => apiCall(API_ENDPOINTS.CRM_DISPOSITIONS);

export const getCrmSettingsViews = async () => apiCall(API_ENDPOINTS.CRM_SETTINGS_VIEWS);
export const getCrmAvailableViews = async () => apiCall(`${API_ENDPOINTS.CRM_SETTINGS_VIEWS}?scope=available`);
export const createCrmView = async (payload) => apiCall(API_ENDPOINTS.CRM_SETTINGS_VIEWS, {
  method: 'POST',
  body: JSON.stringify(payload),
});
export const updateCrmView = async (id, payload) => apiCall(API_ENDPOINTS.CRM_SETTINGS_VIEW(id), {
  method: 'PATCH',
  body: JSON.stringify(payload),
});
export const deactivateCrmView = async (id) => apiCall(API_ENDPOINTS.CRM_SETTINGS_VIEW(id), {
  method: 'DELETE',
});

export const getCrmSettingsDispositions = async () => apiCall(API_ENDPOINTS.CRM_SETTINGS_DISPOSITIONS);
export const createCrmDisposition = async (payload) => apiCall(API_ENDPOINTS.CRM_SETTINGS_DISPOSITIONS, {
  method: 'POST',
  body: JSON.stringify(payload),
});
export const updateCrmDisposition = async (id, payload) => apiCall(API_ENDPOINTS.CRM_SETTINGS_DISPOSITION(id), {
  method: 'PATCH',
  body: JSON.stringify(payload),
});
export const deactivateCrmDisposition = async (id) => apiCall(API_ENDPOINTS.CRM_SETTINGS_DISPOSITION(id), {
  method: 'DELETE',
});

export const getCrmSettingsHubNumbers = async () => apiCall(API_ENDPOINTS.CRM_SETTINGS_HUB_NUMBERS);
export const saveCrmHubNumbers = async (hubId, payload) => apiCall(API_ENDPOINTS.CRM_SETTINGS_HUB_NUMBER(hubId), {
  method: 'PUT',
  body: JSON.stringify(payload),
});

export const getCrmSettingsSmartfloAgents = async ({ page = 1, limit = 10, search = '', assignment = 'all' } = {}) => {
  const query = new URLSearchParams({
    page: String(page),
    limit: String(limit),
    assignment,
  });
  if (search.trim()) query.set('search', search.trim());
  return apiCall(`${API_ENDPOINTS.CRM_SETTINGS_SMARTFLO_AGENTS}?${query}`);
};
export const getCrmSettingsSmartfloCallerIds = async () => apiCall(API_ENDPOINTS.CRM_SETTINGS_SMARTFLO_CALLER_IDS);
export const getCrmSettingsSmartfloRoles = async () => apiCall(API_ENDPOINTS.CRM_SETTINGS_SMARTFLO_ROLES);
export const createCrmSmartfloAgent = async (payload) => apiCall(API_ENDPOINTS.CRM_SETTINGS_SMARTFLO_AGENTS, {
  method: 'POST',
  body: JSON.stringify(payload),
});
export const deleteCrmSmartfloAgent = async (smartfloUserId) => apiCall(
  API_ENDPOINTS.CRM_SMARTFLO_USER(smartfloUserId),
  { method: 'DELETE' }
);
